export type HomeLeadSlice = {
  id: string;
  label: string;
  count: number;
  background: string;
  color: string;
};

function formatCount(count: number): string {
  return Math.trunc(count).toLocaleString('es');
}

function pieBackground(slices: HomeLeadSlice[], total: number): string {
  let cursor = 0;
  const stops: string[] = [];
  const gap = slices.length > 1 ? 1.4 : 0;
  for (const slice of slices) {
    const start = (cursor / total) * 360;
    cursor += slice.count;
    const end = (cursor / total) * 360;
    const paintedEnd = Math.max(start, end - gap);
    stops.push(`${slice.color} ${start}deg ${paintedEnd}deg`);
    if (gap > 0 && end > paintedEnd) stops.push(`transparent ${paintedEnd}deg ${end}deg`);
  }
  return `conic-gradient(${stops.join(', ')})`;
}

export function HomeLeadsPie({ slices }: { slices: HomeLeadSlice[] }) {
  const shown = slices.filter((slice) => slice.count > 0);
  const total = shown.reduce((sum, slice) => sum + slice.count, 0);
  const summary =
    total === 0
      ? 'No hay conversaciones nuevas en este período.'
      : shown.map((slice) => `${slice.label}: ${formatCount(slice.count)}`).join(', ');

  return (
    <section className="home-leads" aria-label="Leads del período">
      <h2 className="pwa-muted home-leads__title">Leads</h2>
      <p className="pwa-muted home-leads__caption">Conversaciones nuevas del período, según su estado.</p>
      {total === 0 ? (
        <p className="pwa-muted home-leads__empty">{summary}</p>
      ) : (
        <div className="home-leads__layout">
          <div
            className="home-leads__pie"
            style={{ background: pieBackground(shown, total) }}
            role="img"
            aria-label={summary}
          />
          <ul className="home-leads__legend">
            {shown.map((slice) => {
              const percent = Math.round((slice.count / total) * 100);
              return (
                <li key={slice.id}>
                  <span className="home-leads__swatch" style={{ background: slice.color }} aria-hidden />
                  <span className="home-leads__label">{slice.label}</span>
                  <span className="home-leads__count">
                    {formatCount(slice.count)}
                    <span className="home-leads__percent"> {percent}%</span>
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </section>
  );
}
